s
<template>
  <div class="product-container">
    <div class="ly--outer--container">
      <div class="relative product-wrapper">
        <ImageWrapper
          src="/assets/images/2025__product__bg.png"
          alt=""
          class="product-bg"
        />
        <div class="ly--content--container noPadding relative">
          <ImageWrapper
            src="/assets/images/2025/product_flower1.png"
            class="product-flower1"
            alt=""
          />
          <div class="product-title-section">
            <TitleSection>{{ $t("productSection.title") }}</TitleSection>
          </div>

          <div class="product-section">
            <!-- Product Images -->
            <div class="product-images">
              <!-- Vector Decoration -->
              <div class="vector-decoration">
                <ImageWrapper
                  src="/assets/images/vector-decoration.svg"
                  alt="Decoration"
                  class="vector-image"
                />
              </div>

              <!-- Main Product Image -->
              <div
                class="main-product-image"
                v-vue-aos.once="{
                  animationClass: 'animate__animated animate__fadeIn',
                }"
              >
                <ImageWrapper
                  v-for="(color, index) in productDataSource"
                  :key="'main-' + color.sku"
                  :src="color.img"
                  :alt="color.name"
                  class="product-image"
                  v-show="selectedColorIndex === index"
                />
              </div>
            </div>
            <!-- Product Card Container -->
            <div
              class="product-card-container"
              v-vue-aos.once="{
                animationClass: 'animate__animated animate__fadeIn',
              }"
            >
              <div class="product-card">
                <div class="product-content">
                  <!-- Product Content START -->
                  <div class="product-content__inner">
                    <!-- Product Title -->
                    <h2
                      class="product-title col__productName"
                      v-html="selectedColor.name"
                    ></h2>

                    <!-- Product Description -->
                    <ul class="product-description">
                      <li v-for="item in selectedColor.desc" :key="item">
                        {{ item }}
                      </li>
                    </ul>

                    <!-- Product Details Row -->
                    <div class="product-details-row">
                      <!-- Color Selection -->
                      <div class="color-selection">
                        <p class="color-label">
                          <span class="color-label-text">{{
                            $t("productSection.colorSelected")
                          }}</span>
                          <span class="selected-color-name">{{
                            selectedColor.colorName
                          }}</span>
                        </p>

                        <!-- Color Options -->
                        <div class="color-options">
                          <div
                            v-for="(color, index) in productDataSource"
                            :key="color.sku"
                            class="color-option"
                            :class="{ active: selectedColorIndex === index }"
                            @click="selectColor(index)"
                          >
                            <div
                              class="color-circle"
                              :style="{ backgroundColor: color.colorCode }"
                            ></div>
                          </div>
                        </div>
                      </div>

                      <!-- Price Section -->
                      <div class="price-section">
                        <div class="current-price">
                          HK ${{ selectedColor.price }}
                        </div>
                        <div class="price-details">
                          <span class="original-price"
                            >HK ${{ selectedColor.orgPrice }}</span
                          >
                          <div class="discount-badge">
                            <span class="discount-percentage">{{
                              selectedColor.discount
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Add to Cart Button -->
                    <div class="col__black">
                      <AddToCart
                        v-for="(color, index) in productDataSource"
                        :key="'addtocart-' + color.sku"
                        :id="color.sku"
                        v-show="selectedColorIndex === index"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AddToCart } from "../index.js";

import TitleSection from "../molecules/TitleSection.vue";
import ImageWrapper from "../atoms/ImageWrapper.vue";

export default {
  name: "ProductSection",

  components: {
    TitleSection,
    AddToCart,
    ImageWrapper,
  },

  data() {
    return {
      selectedColorIndex: 0,
    };
  },

  computed: {
    /**
     * Product data source: prefer prop, otherwise use translation productSectionData
     * @returns {Array}
     */
    productDataSource() {
      if (Array.isArray(this.productData) && this.productData.length) {
        return this.productData;
      }
      const i18nData = this.$t("productSectionData");
      return Array.isArray(i18nData) ? i18nData[0] || [] : [];
    },
    /**
     * Returns the currently selected color object
     * @returns {Object} Selected color data
     */
    selectedColor() {
      return (
        this.productDataSource[this.selectedColorIndex] ||
        this.productDataSource[0] ||
        {}
      );
    },
  },

  methods: {
    /**
     * Handles color selection
     * @param {number} index - Index of the selected color
     */
    selectColor(index) {
      this.selectedColorIndex = index;
      this.$emit("color-changed", this.selectedColor);
    },

    /**
     * Handles add to cart action
     */
    addToCart() {
      const productToAdd = {
        ...this.selectedColor,
        selectedColorIndex: this.selectedColorIndex,
      };
      this.$emit("add-to-cart", productToAdd);
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.col__productName {
  @include media-breakpoint-down(md) {
    font-size: 1.0625rem;
  }
}

.product-flower1 {
  position: absolute;
  top: -50px;
  left: 0%;
  width: 17.9375rem;
  height: auto;

  @include media-breakpoint-down(md) {
    width: rem(128);
  }
}

.product-container {
  .ly--outer--container {
    width: 100%;
  }
  width: 100%;
  position: relative;
  z-index: 2;
}

.product-wrapper {
  padding-bottom: 100px;
  padding-top: 50px;
}

.product-bg {
  position: absolute;
  height: 821px;
  width: auto;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  object-fit: cover;

  @include media-breakpoint-down(lg) {
    height: 100%;
  }
}

.product-section {
  > div {
    width: 50%;
    @include media-breakpoint-down(lg) {
      width: 100%;
    }
  }
  position: relative;
  // min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  @include media-breakpoint-down(lg) {
    flex-direction: column;
    // padding: rem(16);
    gap: rem(24);
    max-width: rem(768);
    margin: auto;
  }

  .product-images {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    // position: absolute;
    // left: rem(84);
    // top: 50%;
    // transform: translateY(-50%);
    // z-index: 1;

    // @include media-breakpoint-down(lg) {
    //   position: relative;
    //   left: 0;
    //   top: 0;
    //   transform: none;
    //   margin-top: rem(24);
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    // }

    .vector-decoration {
      position: absolute;
      top: 20%;
      left: 50%;
      width: 94%;
      height: auto;
      transform: translateX(-50%) rotate(333.843deg);
      z-index: 1;

      .vector-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .main-product-image {
      position: relative;
      z-index: 2;
      width: rem(262);
      height: rem(351);
      display: flex;
      justify-content: center;
      align-items: center;

      @include media-breakpoint-down(lg) {
        width: rem(200);
        height: rem(267);
      }

      .product-image {
        width: 180%;
        height: auto;
        object-fit: contain;
      }
    }

    .additional-images {
      position: absolute;
      bottom: rem(0);
      left: rem(0);
      z-index: 3;
      width: 100%;
      height: 100%;

      .additional-image {
        position: absolute;

        &.towel-image {
          width: 215/612 * 100%;
          height: auto;
          bottom: 23%;
          left: 54%;
        }

        &.spoon-image {
          width: 308/612 * 100%;
          height: auto;
          bottom: 7%;
          left: 14%;
        }
      }
    }
  }
}

.product-title-section {
  margin-bottom: rem(60);

  @include media-breakpoint-down(md) {
    margin-bottom: rem(20);
  }
}

.product-card-container {
  position: relative;
  z-index: 2;
  // max-width: rem(576);
  // width: 50%;

  .product-card {
    position: relative;

    overflow: hidden;
    background-color: color(howToBackground);
    background-image: url("https://s3.ap-southeast-1.amazonaws.com/nespresso.web/2025double11/assets/images/product-background.png");
    background-size: cover;

    .product-background {
      /*
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;

      background-image: url("https://s3.ap-southeast-1.amazonaws.com/nespresso.web/2025double11/assets/images/product-background.png");
      background-size: cover;
*/

      // .background-image {
      //   width: 100%;
      //   height: 100%;
      //   object-fit: cover;
      // }

      .background-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(245, 225, 212, 0.2);
      }
    }

    .product-content {
      position: relative;
      z-index: 2;
      padding: rem(24);

      margin: rem(12);
      border: 2px solid color(nespressoBrown);
      border-radius: rem(20);

      .product-title {
        font-weight: 700;
        font-size: rem(32);
        line-height: 1.2;
        letter-spacing: rem(3.2);
        text-transform: uppercase;
        // color: color(nespressoDarkBrown);
        text-align: left;
        margin: 0;

        @include media-breakpoint-down(md) {
          font-size: rem(17);
          letter-spacing: rem(2.4);
        }
      }

      .product-description {
        list-style-type: disc;
        padding-left: 1em;
        font-weight: 600;
        font-size: rem(20);
        line-height: normal;
        color: color(black);
        // text-align: center;
        margin: 0;

        @include media-breakpoint-down(md) {
          font-size: rem(16);
        }
      }

      .product-details-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        gap: rem(24);

        @include media-breakpoint-down(md) {
          flex-direction: column-reverse;
          gap: rem(16);
        }

        .color-selection {
          display: flex;
          flex-direction: column;
          gap: rem(8);
          opacity: 0.8;

          .color-label {
            font-size: rem(16);
            line-height: 1.2;
            letter-spacing: rem(0.8);
            color: color(black);
            margin: 0;

            .color-label-text {
              font-weight: 400;
            }

            .selected-color-name {
              font-weight: 700;
            }
          }

          .color-options {
            display: flex;
            gap: rem(8);

            .color-option {
              width: rem(34);
              height: rem(34);
              border-radius: 50%;
              border: 2px solid transparent;
              cursor: pointer;
              transition: all 0.3s ease;
              display: flex;
              align-items: center;
              justify-content: center;

              &.active {
                border-color: #a1a1a1;
                transform: scale(1.1);
              }

              &:hover {
                transform: scale(1.05);
              }

              .color-circle {
                width: rem(26);
                height: rem(26);
                border-radius: 50%;
                border: 1px solid rgba(0, 0, 0, 0.1);
              }
            }
          }
        }

        .price-section {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: rem(4);

          @include media-breakpoint-down(md) {
            align-items: center;
          }

          .current-price {
            font-weight: 700;
            font-size: rem(48);
            line-height: normal;
            color: color(black);

            @include media-breakpoint-down(md) {
              font-size: rem(36);
            }
          }

          .price-details {
            display: flex;
            align-items: center;
            gap: rem(8);

            .original-price {
              font-weight: 300;
              font-size: rem(24);
              line-height: normal;
              color: color(black);
              text-decoration: line-through;
              text-decoration-skip-ink: none;
              text-underline-position: from-font;

              @include media-breakpoint-down(md) {
                font-size: rem(18);
              }
            }

            .discount-badge {
              background: color(errorRed);
              color: color(white);
              padding: rem(2) rem(8);
              height: rem(28);
              display: flex;
              align-items: center;
              gap: rem(4);

              .discount-percentage {
                font-weight: 700;
                font-size: rem(16);
                letter-spacing: rem(1.6);
              }

              .discount-text {
                font-weight: 500;
                font-size: rem(14);
              }
            }
          }
        }
      }
    }

    .product-content__inner {
      max-width: 31rem;
      margin: auto;
      // padding: rem(24);
      gap: rem(24);
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;

      @include media-breakpoint-down(md) {
        // padding: rem(24) rem(20) rem(16);
        gap: rem(16);
      }
    }
  }
}
</style>
